/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NumericQuantityDto } from './NumericQuantityDto';
import {
    NumericQuantityDtoFromJSON,
    NumericQuantityDtoFromJSONTyped,
    NumericQuantityDtoToJSON,
} from './NumericQuantityDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfNumericQuantityDto
 */
export interface ODataPostProcessedResultsOfNumericQuantityDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<NumericQuantityDto>}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    value?: Array<NumericQuantityDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    $type?: ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericQuantityDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericQuantityDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum = typeof ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfNumericQuantityDto interface.
 */
export function instanceOfODataPostProcessedResultsOfNumericQuantityDto(value?: unknown): value is ODataPostProcessedResultsOfNumericQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfNumericQuantityDtoFromJSON(json: any): ODataPostProcessedResultsOfNumericQuantityDto {
    return ODataPostProcessedResultsOfNumericQuantityDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfNumericQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfNumericQuantityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(NumericQuantityDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfNumericQuantityDtoToJSON(value?: ODataPostProcessedResultsOfNumericQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(NumericQuantityDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

